qtee.customDesign = window.qtee.customDesign || {};

qtee.customDesign.NewTextView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/text-edit',
	ui: {
		// add new text element functionality
		newTextVal: '.textValue',
		textDone: '.done',
		font: '.textFontBtn',
		size: '.textSizeBtn',
		icons: '.icon',
		charCounter: '.charCounter',
		forwardBtn: '#textElement .forwardText',
		backwardBtn: '#textElement .backwardText',
		duplicateBtn: '#textElement .duplicateText',
		commonControls: '.commonControl'
	},
	events: {
		'click @ui.textDone': 'doneBtnClicked',
		'click @ui.font:not(.disabled)': 'textFontClick',
		'click @ui.size:not(.disabled)': 'textSizeClick',
		'click @ui.forwardBtn:not(.disabled)': 'forwardClick',
		'click @ui.backwardBtn:not(.disabled)': 'backClick',
		'click @ui.duplicateBtn:not(.disabled)': 'duplicateClick',
		'blur @ui.newTextVal': 'updateModel',
		'input @ui.newTextVal': 'textValInput',
		'keydown @ui.newTextVal': 'textFilterKeyDown',
		'keypress @ui.textDone': 'textDoneKeyPress'
	},
	initialize (opts) {

		this.canvasEl = qtee.customDesign.canvas.getElement({ cid: this.model.cid });
		this.$events = $(qtee.customDesign);

		// state of view
		this.state = {
			busy: {
				element: false,
				model: false
			}
		};

		if (opts && opts.update) {

			this.state.duplicating = true;
			this.updateModel();
			this.updateElement();

		}

	},
	onRender () {

		// if duplicating, use the value that's being passed in
		if (this.state.duplicating) {

			this.ui.newTextVal.val(this.model.get('Text'));

		}

		// fix for IE input event
		// @see https://connect.microsoft.com/IE/feedback/details/810538/ie-11-fires-input-event-on-focus
		this.state.oldText = this.ui.newTextVal.val();

	},
	onDomRefresh () {

		this._focus();

	},
	onAttach () {

		this.updateCounter();
		this.updateElementsControls(this.canvasEl, this.state.duplicating);

	},
	_focus () {

		const tmp = this.ui.newTextVal.val();
		this.ui.newTextVal.val('').focus().val(tmp);

	},

	textDoneKeyPress (e) {

		if (e.keyCode === 13) {

			this.doneBtnClicked();

		}

	},

	doneBtnClicked () {

		// get count
		const count = this.ui.newTextVal.val().length;

		if (count == 0) {

			$('#newTextElement').hide();
			$('#editTextElement').hide();
			$('.restartUndoGroup').addClass('active');

		}

		qtee.customDesign.canvas.selectElement(-1);
		qtee.customDesign.canvas.removeEmptyTextElements();

		$('html,body').animate({ scrollTop: $('#prodDetailsTop').offset().top }, 'slow');

	},
	/** Filter to prevent new lines for text elements */
	textFilterKeyDown (e) {

		return e.keyCode !== 13;

	},
	textFontClick () {

		const that = this;
		this.$events.triggerHandler('showFontTextView', {
			model: this.model,
			backCallback: function backCallback () {

				$(qtee.customDesign).trigger('selected.elements.canvas', qtee.customDesign.canvas.getSelected());

			}
		});

	},
	textSizeClick () {

		const that = this;

		this.$events.triggerHandler('showSizeTextView', {
			model: this.model,
			backCallback: function backCallback () {

				$(qtee.customDesign).trigger('selected.elements.canvas', qtee.customDesign.canvas.getSelected());

			}
		});

	},
	cancelModel () {

		const that = this;

		if (!this.state.busy.model) {

			this.state.busy.model = true;
			// if model was not deleted nor created yet then delete it
			if (this.model.lastOperation != 'delete' && undefined != this.model.lastOperation) {

				this.model.destroy({
					wait: true,
					success (r) {

						that.$events.triggerHandler('add.history', [ [ r ] ]);

					}
				});

			}

		}

	},
	cancelElement () {

		if (!this.state.busy.element) {

			this.state.busy.element = true;
			// if svg element was not deleted yet then delete it too
			if (this.canvasEl && !this.canvasEl.isRemoved()) {

				qtee.customDesign.canvas.removeElement({ cid: this.canvasEl.cid });

			}

		}

	},
	textCancelClick () {

		// show default section
		!this.state.canceled && this.$events.triggerHandler('showDefaultSection');
		this.state.canceled = true;

		this.cancelModel();
		this.cancelElement();

	},
	updateCounter () {

		// get count
		let count = this.ui.newTextVal.val().length;

		if (count >= 50) {

			count = 50;

		}

		// update remaining chars in front end
		this.ui.charCounter.text(50 - count);

		if (count < 1) {

			$(this.ui.icons).addClass('disabled');

		} else {

			$(this.ui.icons).removeClass('disabled');

		}

	},
	textValInput (e, force) {

		const that = this;
		const newText = this.ui.newTextVal.val();
		var checkBorders = function (size) {

			if (
				qtee.customDesign.canvas.isOutside({
					width: that.model.get('AreaWidth'),
					height: that.model.get('AreaHeight')
				})
			) {

				let this_size = size || that.canvasEl.getFontSize();

				// set cap at 2
				if (this_size <= 1) {

					this_size = 2;

				}

				that.canvasEl.setFontSize(--this_size);

				that.updateElement();

				checkBorders(this_size);

			}

		};

		checkBorders();

		// update counter as user types
		this.updateCounter();
		this.updateElementsControls(this.canvasEl);

		// if new text is valid
		if (qtee.customDesign.settings.limits.textValid(newText)) {

			// IE fires input event on creation when input element has placeholder
			// @see https://connect.microsoft.com/IE/feedback/details/810538/ie-11-fires-input-event-on-focus
			if (this.state.oldText != newText || force) {

				this.state.oldText = newText;

				if (newText.length > 0) {

					this.ui.textDone.removeClass('off');

				} else {

					this.ui.textDone.addClass('off');

				}

				if (force) {

					this.updateModel();

				}
				this.updateElement();

			}

		} else {

			// restore if new text is not valid
			this.ui.newTextVal.val(this.state.oldText);

		}

	},
	updateElement () {

		if (this.state.busy.element) {

			return;

		}

		const that = this;
		const text = this.state.duplicating ? this.model.get('Text') : $(this.ui.newTextVal).val();

		that.state.busy.element = true;

		if (text && (!this.canvasEl || (this.canvasEl && this.canvasEl.isRemoved())) && text.length > 0) {

			this.model.set({ Text: text });
			qtee.customDesign.canvas.add(this.model).then((el) => {

				// once we get response we unmark svg element as waiting
				that.state.busy.element = false;
				that.canvasEl = el;

				if (that.state.canceled) {

					that.cancelElement();
					return;

				}

				that.canvasEl.cid = that.model.cid;

				that.keepSectionVisible();

				if (el.getText() !== text) {

					that.updateElement();

				}

			});

		} else if (text.length === 0) {

			qtee.customDesign.canvas.removeElement({ cid: this.canvasEl.cid });
			that.keepSectionVisible();
			this.canvasEl
				.setText(text)
				.then(() => {

					that.state.busy.element = false;

				})
				.catch(() => {});

		} else if (text) {

			this.canvasEl
				.setText(text)
				.then((el) => {

					that.state.busy.element = false;

					if (that.state.canceled) {

						that.cancelElement();
						return;

					}

					if (el.getText() !== text) {

						that.updateElement();

					}

				})
				.catch(() => {
					/* nothing for rejected old text */
				});

		}

	},
	updateModel () {

		if (this.state.busy.model) {

			return;

		}

		const that = this;
		const text = this.state.duplicating ? this.model.get('Text') : $(this.ui.newTextVal).val();
		let stopLoader;

		this.state.busy.model = true;

		if (text && this.model.isNew() && text.length > 0) {

			stopLoader = this.$events.triggerHandler('startLoader', 0);
			this.model.set({ Text: text });
			this.options.textCollection.create(this.model, {
				wait: true,
				success (r) {

					stopLoader();
					that.state.busy.model = false;
					if (that.canvasEl) {

						that.canvasEl.cid = that.model.cid;

					}

					if (that.state.canceled) {

						that.cancelModel();
						return;

					}

					that.$events.triggerHandler('add.history', [ [ r ] ]);
					if (r.get('Text') != text && !r.get('CustomizedProductToken')) {

						that.updateModel();

					}

				}
			});

		} else if (text && text.length == 0) {

			// delete
			this.model.destroy({
				wait: true,
				success (r) {

					that.state.busy.model = false;
					that.$events.triggerHandler('add.history', [ [ r ] ]);

					if (that.state.canceled) {

						that.cancelModel();
						return;

					}

					// reset model
					that.model.set({ Token: void 0 });
					that.model.lastOperation = undefined;

					if (text.length > 0) {

						that.updateModel();

					}

				}
			});

		} else if (text) {

			// update
			that.model
				.delayedSave(
					{ Text: text },
					{
						wait: true,
						success (r) {

							that.state.busy.model = false;
							that.$events.triggerHandler('add.history', [ [ r ] ]);

							if (that.state.canceled) {

								that.cancelModel();
								return;

							}

							if (r.get('Text') != text && !r.get('CustomizedProductToken')) {

								that.updateModel();

							}

						}
					}
				)
				.catch(() => {
					/* do nothing for rejected delayaed save */
				});

		}

	},
	keepSectionVisible () {

		this.$events.triggerHandler('showNewTextSection');
		this._focus();

	},
	forwardClick (e) {

		qtee.customDesign.canvas.moveUpSelected();
		this.updateElementsControls(this.canvasEl);

	},
	backClick (e) {

		qtee.customDesign.canvas.moveDownSelected();
		this.updateElementsControls(this.canvasEl);

	},
	duplicateClick (e) {

		const el = qtee.customDesign.canvas.getSelected();
		const startX = this.model.get('AreaWidth') / 2;
		const startY = this.model.get('AreaHeight') / 2;
		let { rotate } = el.element.rel.freeTransform.attrs;
		const start = qtee.customDesign.utils.calcDuplicatePosition('text', startX, startY, rotate);

		rotate = rotate < 0 ? 360 + rotate : rotate;

		// must disable duplicate button to prevent rapid clicking, until the model is updated from server
		$(this.ui.duplicateBtn).addClass('disabled');

		this.$events.triggerHandler('cloneText', {
			clonedText: el.element._text,
			update: true,
			x: start.x,
			y: start.y,
			rotation: rotate,
			fontSize: el.element.rel.freeTransform.attrs.scale.x * el.element._fontSize
		});

	},
	updateElementsControls (element, clone) {

		const selectors = [ '.textFontBtn', '.textSizeBtn', '#colorTextBtn', '#centerTextBtn', '.straightEl', '.delete' ];
		const checkDuplicateBtn = () => {

			let limit = qtee.customDesign.settings.limits.text;

			limit = clone ? --limit : limit;

			if (qtee.customDesign.canvas.getAllElementsByType('text').length < limit) {

				$(this.ui.duplicateBtn).removeClass('disabled');

			}

		};

		// always disable duplicate button first
		$(this.ui.duplicateBtn).addClass('disabled');

		if (this.ui.newTextVal.val() == '') {

			selectors.forEach((selector) => {

				$(selector).addClass('disabled');

			});

		} else {

			selectors.forEach((selector) => {

				$(selector).removeClass('disabled');

			});

		}

		if (element) {

			$(this.ui.commonControls).removeClass('disabled');

			if (qtee.customDesign.canvas.elements.length <= 1) {

				$(this.ui.commonControls).addClass('disabled');

			} else if (qtee.customDesign.canvas.isElementOnBack(element)) {

				$(this.ui.backwardBtn).addClass('disabled');

			} else if (qtee.customDesign.canvas.isElementOnFront(element)) {

				$(this.ui.forwardBtn).addClass('disabled');

			}

			checkDuplicateBtn();

		} else if (clone) {

			$(this.ui.commonControls).removeClass('disabled');
			$(this.ui.forwardBtn).addClass('disabled');

			checkDuplicateBtn();

		} else {

			$(this.ui.commonControls).addClass('disabled');

		}

	}
});

qtee.customDesign.EditTextView = qtee.customDesign.NewTextView.extend({
	templateHelpers: {
		headerText: 'Edit text'
	},
	initialize (opts) {

		qtee.customDesign.NewTextView.prototype.initialize.call(this, opts);

		// save initial model data for restoration if customer clicks 'cancel'
		this.initElState = this.canvasEl.saveToModel();

		if (this.initElState.Text !== this.model.get('Text')) {

			this.model.set({ Text: this.initElState.Text });

		}

	},
	textFontClick () {

		const that = this;

		this.$events.triggerHandler('showFontTextView', {
			model: this.model,
			backCallback (e) {

				that.$events.triggerHandler('showEditTextSection');
				that._focus();
				e && e.fontChangedTo && that.ui.textDone.removeClass('off');

			}
		});

	},
	cancelModel () {

		const that = this;

		this.model.set(this.initElState);

		if (this.model.delayedSave.purge()) {

			this.state.busy.model = false;

		}

		if (!that.state.busy.model) {

			that.state.busy.model = true;
			// update model if model was not removed otherwise crete new based on initial
			if (this.model.lastOperation != 'delete' && undefined != this.model.lastOperation) {

				this.model.save(this.initElState, {
					wait: false,
					success (r) {

						that.$events.triggerHandler('add.history', [ [ r ] ]);
						that.state.canceledStopLoader && that.state.canceledStopLoader();

					}
				});

			} else {

				this.model = this.options.textCollection.create(this.initElState, {
					wait: false,
					success (r) {

						that.$events.triggerHandler('add.history', [ [ r ] ]);
						if (that.canvasEl) {

							that.canvasEl.cid = that.model.cid;

						}
						that.state.canceledStopLoader && that.state.canceledStopLoader();

					}
				});

			}

		}

	},
	cancelElement () {

		const that = this;

		if (!this.state.busy.element) {

			this.state.busy.element = true;
			// update canvas element if canvas element was not removed
			if (this.canvasEl && !this.canvasEl.isRemoved()) {

				const font = qtee.customDesign.fonts.parseFontName(this.initElState.FontName);

				this.canvasEl.setText(this.initElState.Text);
				this.canvasEl.setFont(font.family, font.weight, this.initElState.IsItalic ? 'italic' : 'normal');

			} else {

				qtee.customDesign.canvas.add(this.model).then(
					(el) => {

						that.canvasEl = el;
						that.canvasEl.cid = that.model.cid;

					},
					(reason) => {
						// TODO: handler when canvas was not able to create element
					}
				);

			}

		}

	},
	textCancelClick () {

		this.state.canceledStopLoader = this.$events.triggerHandler('startLoader');

		!this.state.canceled && this.$events.triggerHandler('showTextSection');
		this.state.canceled = true;

		this.cancelModel();
		this.cancelElement();

	},
	keepSectionVisible () {

		this.$events.triggerHandler('showEditTextSection');
		this._focus();

	}
});
